import { syncUserRole } from "../api/client";

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateUsername = (username: string): boolean => {
  // Username: 1–128 characters, allows letters, numbers, underscore, hyphen, and dot.
  const usernameRegex = /^[a-zA-Z0-9._-]{1,128}$/;
  return usernameRegex.test(username);
};

export const validatePassword = (password: string) => {
  const errors: string[] = [];

  if (!password || password.length < 8) {
    return {
      errorMessage: "Password must be at least 8 characters long.",
      isError: true,
    };
  }

  if (!/[a-z]/.test(password)) {
    errors.push("one lowercase letter");
  }

  if (!/[A-Z]/.test(password)) {
    errors.push("one uppercase letter");
  }

  if (!/\d/.test(password)) {
    errors.push("one number");
  }

  const specialCharactersRegex = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;

  if (!specialCharactersRegex.test(password)) {
    errors.push(
      "one special character. Valid special characters are: !\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~",
    );
  }

  if (errors.length === 0) {
    return {
      errorMessage: null,
      isError: false,
    };
  }

  let message = "Password must contain at least ";
  if (errors.length === 1) {
    message += errors[0] + ".";
  } else {
    message +=
      errors.slice(0, -1).join(", ") +
      ", and " +
      errors[errors.length - 1] +
      ".";
  }

  return {
    errorMessage: message.trim(),
    isError: true,
  };
};

export const validateVerificationCode = (code: string) => {
  const verificationCodeRegex = /^\d{6}$/;

  if (!verificationCodeRegex.test(code)) {
    return {
      errorMessage: "Please provide a valid verification code.",
      isError: true,
    };
  }

  return {
    errorMessage: null,
    isError: false,
  };
};

export interface PasswordRequirement {
  text: string;
  met: boolean;
}

export const getPasswordRequirements = (
  password: string,
): PasswordRequirement[] => {
  const requirements: PasswordRequirement[] = [];

  requirements.push({
    text: "at least 8 characters",
    met: password.length >= 8,
  });

  requirements.push({
    text: "1 lowercase letter",
    met: /[a-z]/.test(password),
  });

  requirements.push({
    text: "1 uppercase letter",
    met: /[A-Z]/.test(password),
  });

  requirements.push({
    text: "1 number",
    met: /\d/.test(password),
  });

  const specialCharactersRegex = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
  requirements.push({
    text: "1 special character (!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~)",
    met: specialCharactersRegex.test(password),
  });

  return requirements;
};

export const syncUserRoleAfterLogin = async () => {
  try {
    await syncUserRole();
  } catch (error) {
    return {
      errorMessage: "Error syncing user role",
      isError: true,
    };
  }
};
